import React, { Component } from 'react';
import { observable, runInAction, reaction, makeObservable } from 'mobx';
import {  observer } from 'mobx-react'
import { Tooltip } from '@mui/material';
import { Warning } from '@mui/icons-material';
import GabineteStore from '@/store/GabineteStore';

interface IPropsAlertaFalhaNoEnvelope {
}

class AlertaFalhaNoEnvelope extends React.Component {
    mensagem = 'Falha na atualização das informações do sistema. Por favor atualize a página';
    mostrarAlerta = false;
    idtimeout;

    reactionAtualizacaoEnvelope = reaction(() => GabineteStore.ultimaAtualizacaoEnvelope, () => {
        if (this.idtimeout) {
            window.clearTimeout(this.idtimeout);
        }
        this.idtimeout = setTimeout(() => {
            runInAction(() => {
                this.mensagem = 'O sistema pode estar com os dados desatualizados. Por favor atualize a página.';
                this.mostrarAlerta = true;
            });
        }, 1000 * 60 * 60 * 3); // 3horas
    });

    constructor(props: IPropsAlertaFalhaNoEnvelope) {
        super(props);

        makeObservable(this, {
            mensagem: observable,
            mostrarAlerta: observable,
            idtimeout: observable
        });
    }

    render() {
        if (!this.mostrarAlerta) {
            return null;
        }
        return (
            <Tooltip title={this.mensagem}>
                <div>
                    <Warning color='secondary' />
                    {/* GabineteStore.ultimaAtualizacaoEnvelope */}
                </div>
            </Tooltip>
        );
    }
}

export default observer(AlertaFalhaNoEnvelope);
